import api from '../utils/api';

export interface UploadLogoResponse {
  logoUrl: string;
}

export const UploadService = {
  async uploadClinicLogo(file: File): Promise<UploadLogoResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/uploads/clinic-logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  async removeClinicLogo(): Promise<{ message: string }> {
    const response = await api.delete('/uploads/clinic-logo');
    return response.data;
  },
};

// Legacy export for backward compatibility
export const uploadService = UploadService;
